import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { getIdentityActiveRoleName } from 'store/entities/identity/selectors'

import RoleName from './RoleName'

const mapStateToProps = state => ({
  roleName: getIdentityActiveRoleName(state),
})

export default connect(mapStateToProps)(withTranslation('admin')(RoleName))
